<template>
    <div class="wrap-app">
        <div class="banner wow fadeInUp" data-wow-delay="0.1s">
            <el-carousel indicator-position="none" :interval="5000">
                <el-carousel-item v-for="item in 4" :key="item">
                    <img :src="require(`@/assets/images/${imageSrc}/banner_${item}.jpg`)" class="banner-img">
                </el-carousel-item>
            </el-carousel>
            <div class="top-info">
                <div class="container">
                    <div class="logo-box">
                        <img src="@/assets/images/pc/logo.png" class="logo">
                        <i class="el-icon-more icon-menu" @click="showMenu = true"></i>
                    </div>
                    <h1>我們是一家科技第一的創意機構</h1>
                    <div class="header" ref="header">
                        <div class="container">
                            <ul class="menu">
                                <li :class="{active: activeMenu === index}" v-for="(item, index) in menu" :key="index" @click="toPostion(index, item.href)">
                                    <p>{{ item.title }}</p>
                                    <p class="desc" v-show="activeMenu === index">{{ item.desc }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pop-menu" v-if="showMenu">
                    <ul><li v-for="(item, index) in menu" :key="item.href" @click="toPostion(index, item.href);showMenu=false">{{ item.title }}</li></ul>
                    <i class="el-icon-close" @click="showMenu = false"></i>
                </div>
            </div>
        </div>
        <section class="about wow fadeInUp" ref="intro" data-wow-delay="0.2s">
            <div class="container">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <img :src="require(`@/assets/images/${imageSrc}/about.jpg`)" class="img-fluid">
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <h1>關於我們</h1>

                        <p>萊森德集團成立於2012年，專注於行動互聯網領域，自主研發以及運營，向廣大互聯網用戶及企業提供多元化的行動互聯產品以及服務。</p>


                        <p>憑藉先進的研發核心技術、敏銳的市場洞察力和廣闊的國際視野，推出了一系列原創的網路產品以及行動互聯網產品。</p>


                        <p>公司自成立之日起，就秉承「人才是第一生產力"的宗旨，致力於打造人才成才的平台。 我們的團隊擁有來自各國網路公司的技術菁英、創意行銷高手及高素質管理人才，形成了不斷創新、充滿活力、勇攀高峰的公司文化。</p>


                        <p>即使在動盪的市場中，也能運用創新但嚴謹的思維來持續實現目標。</p>

                    </el-col>
                </el-row>
        </div>
        </section>

        <section class="bg wow fadeInUp" ref="service" data-wow-delay="0.3s">
            <div class="container">
                <h1>我們的服務</h1>
                <p>我們提供一站式IT技術服務</p>
                <el-row :gutter="60">
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" v-for="(item, index) in service" :key="index">
                        <div class="service-item">
                            <img :src="require(`@/assets/images/pc/ic_service_${index+1}.png`)" class="icon-50">
                            <p>{{ item.title }}</p>
                            <p class="fz-14 text-gray mt-1">{{ item.desc }}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>

        <section ref="global" class="wow fadeInUp" data-wow-delay="0.4s">
            <div class="container">
                <el-row :gutter="60">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <img :src="require(`@/assets/images/${imageSrc}/us.jpg`)" class="img-fluid">
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <h1>我們的辦公室</h1>
                        <p>我們在世界各地設有辦事處，已有百位純技術人員分佈在全球各地</p>
                        <ul class="us-address">
                            <li v-for="(item, index) in usAddress" :key="index">
                                <span>{{ item.name }}</span>
                                <p>{{ item.tel }}<br>{{ item.email }}</p>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div>
        </section>

        <section class="nopad wow fadeInUp" ref="recruit" data-wow-delay="0.5s">
            <img :src="require(`@/assets/images/${imageSrc}/join_bg.jpg`)" class="img-fluid">
            <div class="join-info">
                <div class="container">
                    <h1>加入我們的團隊</h1>
                    <p>歡迎各國志同道合的夥伴們加入我們，
一起為建立高績效組織共同努力 !</p>
                    <a class="btn-contact" href="mailto:fuxiaozhi96@gmail.com"><img src="@/assets/images/pc/ic_telegram.png" class="icon-24">即時諮詢</a>
                    <p class="email"><img src="@/assets/images/pc/ic_email.png" class="icon-24">fuxiaozhi96@gmail.com</p>
                </div>
            </div>
        </section>

        <footer>
            <div class="container">
                <p class="fz-14">Copyright © 2024.Lysonder Corp. All Rights Reserved.</p>
            </div>
        </footer>
    </div>
</template>

<script>
export default{
    data() {
        return{
            activeMenu: 0,
            showMenu: false,
            menu: [
                {title: '公司介绍', desc: '關於我們的工作', href: 'intro'},
                {title: '服務介紹', desc: '一站式IT技术服务', href: 'service'},
                {title: '全球據點', desc: '世界各地设有办事处', href: 'global'},
                {title: '人才招聘', desc: '菁英招募，歡迎加入我們', href: 'recruit'}
            ],
            service: [
                {title: '網站/系統開發', desc: '企業官網建置、品牌官網建置、集團網站建置、響應式網站建置、產業網站開發、電商平台開發、SAAS平台開發'},
                {title: '手機應用開發', desc: '蘋果ios應用開發、安卓Android應用程式開發、小程式開發、html5開發、PWA應用'},
                {title: 'UI/UX 設計', desc: 'APP、網站、智慧型裝置、系統，使用者體驗/互動設計/UI設計，品牌定位/規劃/設計，LOGO、VI、包裝、吉祥物、表情、應用'},
                {title: '營銷推廣', desc: '數位行銷、SEO快排、企推推廣系統、企推行銷系統、網推行銷系統、簡訊行銷、EDM郵件群發、智慧電銷機器人、智慧獲客名片'},
                {title: '運維保障', desc: '系統監控、系統警報、業務備份、維運報告、緊急處理、故障管理、雲端平台遷移、應用容器化、安全評估、滲透測試、安全加強、日誌審計、系統最佳化、緊急應變'},
                {title: '咨詢與顧問', desc: '線上活動策劃、網路行銷策略、電子商務策略、行動體驗方案、企業數位轉型，以使用者需求為中心，利用網路思維迭代服務，指導線上業務開發上線運營'},
            ],
            usAddress: [
                {name: '紐約', tel: '212.358.0717', email: 'ny.info@lysonder.com'},
                {name: '台灣', tel: '120.29567,22.641512', email: 'fuxiaozhi96@gmail.com'},
                {name: '東京', tel: '+81 (0) 70.3890.1920', email: 'fuxiaozhi96@gmail.com'},
                {name: '馬尼拉', tel: '+63 (2) 7625.6515', email: 'mnl.info@lysonder.com'},
                {name: '班加羅爾', tel: '+91-80-41106986', email: 'bjle.info@lysonder.com'},
            ],
            imageSrc: 'pc'
        }
    },
    mounted() {
        this.$nextTick(() => {
        new this.$wow.WOW({live: false}).init(); 
        })
        window.addEventListener('scroll', this.handleScroll);
        // window.addEventListener('resize', this.updateImage); 
        this.updateImage()
    },
    methods: {
        toPostion(index, ref) {
            this.activeMenu = index
            this.$refs[ref].scrollIntoView()
            document.documentElement.scrollTo(0, document.documentElement.scrollTop - 90)
        },
        handleScroll(e) {
            const scrollTop = e.target.scrollingElement.scrollTop;
            if (scrollTop < 300) {
                this.$refs.header.classList.remove("stick");
            } else {
            this.$refs.header.classList.add('stick');
            }
            
        },
        updateImage() {
            const width = window.innerWidth;
            if (width <= 600) {
                this.imageSrc = 'app';
            } else {
                this.imageSrc = 'pc';
            }
        },
    }
}
</script>

<style lang="scss">
@import "@/assets/css/index.scss";
</style>